import { render } from "./ShiftRejectPreview.vue?vue&type=template&id=54b4c12c"
import script from "./ShiftRejectPreview.vue?vue&type=script&lang=js"
export * from "./ShiftRejectPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__